import React from 'react';
import { store } from '../../../../store';

class Profile extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      name: '',
      bio: '',
    }
  }
  componentWillMount() {
    if(store.getState().websiter !== null)
  this.setState({
    name: store.getState().website.name,
    bio: store.getState().website.bio
  })
}
  render() {
  	if(store.getState().activities.edit)  {
            return(
              <div>
              {this.props.highlight === "fullname"
              ? <div className="reg_error"><span><i class="fa fa-exclamation-circle" aria-hidden="true"></i>Write your name</span></div>
              : null
              } 
              <div className="addName"><input
              autocomplete="off"
              spellcheck="false"
              type="text"
              name="fullname"
              className={
                this.props.highlight === "fullname"
                ? 'profile_name disinp redd'
                : 'profile_name disinp'
              }
              value={this.state.name}
              placeholder="Your name..."
              onChange={(e)=>{
                this.setState({name: e.target.value})
                this.props.onWebsitename(e.target.value)
              }}
              onFocus={()=> {
                this.props.onHighlight('')
              }}
              /></div>
              <div className="addDesc"><input
              autocomplete="off"
              type="text"
              className="profile_desc disinp"
              value={this.state.bio}
              placeholder="describe yourself..."
              onChange={(e)=>{
                let { user } = store.getState()
                this.setState({bio: e.target.value})
                this.props.onWebsiteBio(e.target.value)
              }}
              /></div>
              </div>)
        }
     else {
     	return (<span>
              <span className="profile_name">{this.state.name}</span>
              <span className="profile_desc">{this.state.bio}</span>
              </span>)
     }
  }
            
}
export default Profile;